// ============================================================
// 后台路由实例
// 菜单走 GET /admin/user/info → menus
// ============================================================
import { createDynamicRouter } from "@shared/router";
import Layout from "@shared/layout/index.vue";
import { fetchCurrentUserInfo } from "@app/api/user";
import { useCurrentUserStore } from "@app/store/modules/currentUser";
import { staticRoutes } from "./routes";
import "./routePages";

const router = createDynamicRouter({
    staticRoutes,
    fetchUserMenus: async () => {
        const data = await fetchCurrentUserInfo();
        useCurrentUserStore().hydrateFromInfo(data);
        return { menus: data.menus ?? [], buttonPages: data.buttonPages ?? [] };
    },
    layout: Layout,
    whiteList: ["/login", "/404", "/403"],
    baseTitle: import.meta.env.VITE_APP_TITLE || "1P后台",
    loginPage: () => import("@app/views/login.vue"),
    requireAuth: true,
});

export default router;
